import { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/pfc";
import { Check } from "lucide-react";

export default function VendorSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const nav = useNavigate();
  const [vendor, setVendor] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    document.title = "Vendor Payment Confirmed — PFC";
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        // Just refresh /vendor/me — webhook + status endpoint do the upgrade
        await api.get(`/checkout/status/${sessionId}`).catch(() => {});
        const { data } = await api.get("/vendor/me");
        if (cancelled) return;
        if (data.vendor) {
          setVendor(data.vendor);
          if (data.subscription_active) return;
        }
        if (tries < 8) setTimeout(() => setTries((t) => t + 1), 2000);
      } catch {
        if (tries < 8) setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, tries]);

  return (
    <div className="bg-ink-900 min-h-screen text-white py-20 px-5" data-testid="vendor-success">
      <div className="max-w-lg mx-auto text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-pfc-gold/15 border border-pfc-gold rounded-full mb-6">
          <Check size={28} className="text-pfc-gold" />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl mb-3">Payment received</h1>
        <p className="text-white/70 mt-3">
          {vendor?.activation_paid && !vendor?.subscription_active
            ? "Activation complete. Next step: subscribe to keep your storefront live."
            : vendor?.subscription_active
              ? "Your storefront is now active. Start listing products."
              : "Processing your payment…"}
        </p>
        <div className="mt-10 flex gap-3 justify-center">
          {vendor?.activation_paid && !vendor?.subscription_active && (
            <Link to="/vendor/register" className="px-6 py-3 bg-pfc-gold text-ink-900 font-sub uppercase tracking-[0.25em] text-xs hover:bg-pfc-gold-bright" data-testid="continue-subscribe">
              Continue → $9.99/mo
            </Link>
          )}
          {vendor?.subscription_active && (
            <button onClick={() => nav("/vendor/dashboard")} className="px-6 py-3 bg-pfc-gold text-ink-900 font-sub uppercase tracking-[0.25em] text-xs hover:bg-pfc-gold-bright" data-testid="open-dashboard">
              Open Dashboard →
            </button>
          )}
          <Link to="/marketplace" className="px-6 py-3 border border-white/20 text-white font-sub uppercase tracking-[0.25em] text-xs hover:bg-white hover:text-ink-900">
            Marketplace
          </Link>
        </div>
      </div>
    </div>
  );
}
